module.exports = __webpack_public_path__ + "img/arrow-bottom.9bfac1b7.svg";